package com.meistercharts.charts.pv.roofPlanning

/**
 * Returns true if this element and [other] are the same thing as far as selecting and highlighting go.
 *
 * A module belongs to its module area: selecting a module selects the area, and hovering the area highlights the
 * modules. This is the only definition of that relation.
 */
fun Clickable?.belongsToSameElementAs(other: Clickable?): Boolean {
  if (this == null || other == null) {
    return false
  }

  return this == other ||
    (this is Module && this.modulePlacement.moduleArea == other) ||
    (other is Module && this == other.modulePlacement.moduleArea) ||
    (this is Module && other is Module && this.modulePlacement.moduleArea == other.modulePlacement.moduleArea)
}

/**
 * Returns the element that moves and resizes on behalf of this one - a module hands both to its module area.
 */
fun Clickable.resizable(): Resizable {
  return when (this) {
    is Module -> modulePlacement.moduleArea
    is UnusableArea, is ModuleArea -> this
  }
}

/**
 * The nullable sibling of [resizable], for a place that may hold no element at all.
 */
fun Clickable?.resizableOrNull(): Resizable? {
  return this?.resizable()
}
